import type { LabelHTMLAttributes, ReactNode } from "react";
import { cx } from "./cx";
import { CircleAlert, Icon } from "./icon";

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
}

export function Label({ required = false, className, children, ...rest }: LabelProps) {
  return (
    <label className={cx("pz-label", className)} {...rest}>
      {children}
      {required && (
        <span className="pz-label__required" aria-hidden>
          {" *"}
        </span>
      )}
    </label>
  );
}

export interface FieldProps {
  label: ReactNode;
  htmlFor?: string;
  required?: boolean;
  description?: ReactNode;
  error?: ReactNode;
  children: ReactNode;
  className?: string;
}

/** Form-field wrapper: label + control + description + error message. */
export function Field({ label, htmlFor, required = false, description, error, children, className }: FieldProps) {
  return (
    <div className={cx("pz-field", className)}>
      <Label htmlFor={htmlFor} required={required}>
        {label}
      </Label>
      {children}
      {description != null && <span className="pz-field__description">{description}</span>}
      {error != null && (
        <span className="pz-field__error" role="alert">
          <Icon icon={CircleAlert} size="sm" />
          {error}
        </span>
      )}
    </div>
  );
}
